import { ActionButtonGroup } from "@/components/AppGrid/ActionButtons/ActionButtonGroup";
import { EditButton } from "@/components/AppGrid/ActionButtons/EditButton";
import { TrashButton } from "@/components/AppGrid/ActionButtons/TrashButton";
import { contactModel } from "@/models/contact";
import { Route } from "@/paths";
import { CustomCellRendererProps } from "@ag-grid-community/react";
import { generatePath } from "react-router-dom";

export const ActionRenderer = (props: CustomCellRendererProps) => {
  const entity = contactModel.createEntityInstance({
    id: props.data.id,
  });

  return (
    <ActionButtonGroup>
      <EditButton
        path={generatePath(Route.Contact, { contactId: props.data.id })}
      />
      <TrashButton entity={entity} name={props.data.name} />
    </ActionButtonGroup>
  );
};
